module.exports = __webpack_public_path__ + "img/pause.d5ce4014.svg";